import type * as Types from '../../types';

import client from "apollo/client";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMyProfileUserInfoQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type GetMyProfileUserInfoQuery = { __typename?: 'Query', user?: { __typename?: 'User', firstName: string, lastName: string, email: string, id: string, tenantId: string, createdAt: string, userBridgeRoles: Array<{ __typename?: 'UserBridgeRole', role: { __typename?: 'Role', name: string } }>, tenant: { __typename?: 'Tenant', tenantName: string } } | null };


        export type ExecGetMyProfileUserInfoOptions = Omit<
        Apollo.QueryOptions<
        GetMyProfileUserInfoQueryVariables, GetMyProfileUserInfoQuery
        >,
        "query"
      >;
    export const execGetMyProfileUserInfoQuery = (options: ExecGetMyProfileUserInfoOptions) =>
    client.query< GetMyProfileUserInfoQuery, GetMyProfileUserInfoQueryVariables>({
      ...options,
      query: GetMyProfileUserInfoDocument,
    });
    

export const GetMyProfileUserInfoDocument = gql`
    query getMyProfileUserInfo($id: UUID!) {
  user(id: $id) {
    firstName
    lastName
    email
    id
    userBridgeRoles {
      role {
        name
      }
    }
    tenantId
    createdAt
    tenant {
      tenantName
    }
  }
}
    `;

/**
 * __useGetMyProfileUserInfoQuery__
 *
 * To run a query within a React component, call `useGetMyProfileUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProfileUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProfileUserInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyProfileUserInfoQuery(baseOptions: Apollo.QueryHookOptions<GetMyProfileUserInfoQuery, GetMyProfileUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProfileUserInfoQuery, GetMyProfileUserInfoQueryVariables>(GetMyProfileUserInfoDocument, options);
      }
export function useGetMyProfileUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProfileUserInfoQuery, GetMyProfileUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProfileUserInfoQuery, GetMyProfileUserInfoQueryVariables>(GetMyProfileUserInfoDocument, options);
        }
export type GetMyProfileUserInfoQueryHookResult = ReturnType<typeof useGetMyProfileUserInfoQuery>;
export type GetMyProfileUserInfoLazyQueryHookResult = ReturnType<typeof useGetMyProfileUserInfoLazyQuery>;
export type GetMyProfileUserInfoQueryResult = Apollo.QueryResult<GetMyProfileUserInfoQuery, GetMyProfileUserInfoQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
          export type ResultType<T> = Types.ResultType<T>;
          export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
          export type NonMaybe<T> = Types.NonMaybe<T>;
          export type Maybe<T> = Types.Maybe<T>;